module.exports = __webpack_public_path__ + "media/images/emblems/CHE_Latena_COA-4680debdab3e003202f5593c1a779492.svg";